export default __webpack_public_path__ + "static/media/step_D.3ebe2c89.png";